import React, { useState, useEffect } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import axiosClient from "../../axios-client";
import axios from "axios";
import CryptoJS from "crypto-js";

const LoginModal = ({ isOpen, closeModal, onLoginSuccess, payload }) => {
  const location = useLocation();
  const path = location.pathname.split("/").filter(Boolean).pop();
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [keepLoggedIn, setKeepLoggedIn] = useState(false);
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const navigate = useNavigate();
  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!captchaVerified) {
      alert("Please complete the captcha verification.");
      return;
    }
    try {
      const response = await axiosClient.post("/users/login", {
        email,
        password,
      });
      if (response.status === 200) {
        const { token, userId, plan, subscriptionId } = response.data;
        localStorage.setItem("token", token);
        localStorage.setItem("userID", userId);
        sessionStorage.setItem("plans", JSON.stringify(plan));
        sessionStorage.setItem(
          "subscriptionId",
          JSON.stringify(subscriptionId)
        );
        onLoginSuccess();
        closeModal();
        window.location.href = "/profile";
        // navigate("/profile");
      } else {
        alert("Login failed. Please check your credentials.");
      }
    } catch (error) {
      setErrorMessage(error.response.data.message);
      console.error("Login error:", error);
    }
  };

  const onCaptchaChange = async (value) => {
    const payload = {
      token: value,
    };
    try {
      const response = await axiosClient.post("/admin/captcha", payload);

      const data = response.data;
      if (data.success) {
        alert("Form submitted successfully!");
      } else {
        alert("reCAPTCHA verification failed.");
      }
    } catch (error) {
      console.error("Captcha verification error:", error);
    }
    if (value) {
      setCaptchaVerified(true);
    } else {
      setCaptchaVerified(false); // Expired captcha or if there was an issue
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50 font-inter">
      <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-lg relative">
        <button
          onClick={closeModal}
          className="absolute top-1 right-3 text-gray-600 hover:text-gray-900 text-2xl"
        >
          &times;
        </button>
        <div className="bg-lightPink p-6 rounded-xl shadow">
          <h2 className="text-2xl font-semibold mb-4 text-center">
            Log In to Access
          </h2>
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block font-semibold mb-2">
                Email <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2 rounded-md focus:ring-black"
                placeholder="Enter your email address here"
                required
              />
            </div>
            <div className="relative">
              <label className="block font-semibold mb-2">
                Password <span className="text-red-500">*</span>
              </label>
              <input
                type={showPassword ? "text" : "password"}
                className="w-full px-4 py-2 rounded-md focus:ring-black pr-10"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              {errorMessage && (
                <p className="text-red-500 mt-2">{errorMessage}</p>
              )}
              <button
                type="button"
                className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5 mt-8"
                onClick={togglePasswordVisibility}
              >
                {showPassword ? (
                  <FaEye className="h-5 w-5 text-[#1c1b1f]" />
                ) : (
                  <FaEyeSlash className="h-5 w-5 text-[#1c1b1f]" />
                )}
              </button>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="keepLoggedIn"
                  className="w-4 h-4"
                  checked={keepLoggedIn}
                  onChange={(e) => setKeepLoggedIn(e.target.checked)}
                />
                <label htmlFor="keepLoggedIn" className="ml-2 text-[#848484]">
                  Keep me logged in
                </label>
              </div>
              <Link
                to="/forgot-password"
                className=" text-[#34749B] hover:no-underline hover:text-blue-600 underline"
                onClick={closeModal}
              >
                Forgot Password?
              </Link>
            </div>
            <div className="mt-4 flex justify-center">
              <ReCAPTCHA
                sitekey="6LfMEuYqAAAAAEZW-HW-VvYgtDxDofyleKGBSbge"
                onChange={onCaptchaChange}
              />
            </div>
            <button
              type="submit"
              className="w-full bg-login hover:bg-black text-white py-3 rounded-md font-dmSans font-semibold"
              disabled={!captchaVerified}
            >
              Log In
            </button>
            {payload !== undefined && (
              <p className="text-center text-sm text-[#848484] font-medium">
                Haven't Registered yet?{" "}
                <div
                  className="text-black underline hover:text-[#3c3c3c]"
                  onClick={() => payload()}
                >
                  Register Now
                </div>
              </p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
